<template>
  <div class="mid-inner wrap-hero">
    <div class="hero-large">
      <div class="container">
        <div class="info-overlay col-sm-12 col-md-10 col-md-offset-1">
          <h1><span v-html="$root.domainTrademark"></span> Knowledge Base</h1>
          <form :action="`/search/${URLSlugify(searchText)}`">
            <input type="text" placeholder="Search..." v-model="searchText">
          </form>
        </div>
      </div>
    </div>
    <div class="knowledge-base-bottom">
      <div class="text-center" v-show="loadingCategories">
        <Spinner color="#3982c4" />
      </div>
      <div class="container">
        <div v-for="articleCategory in articleCategories" :key="articleCategory.index">
          <div class="kb-section" v-show="articleCategory.articles.length">
            <h2 v-if="articleCategory.articles.length">{{ articleCategory.category.name }}</h2>
            <ol v-show="!loadingCategories">
              <li v-for="article in articleCategory.articles" :key="article.index">
                <span v-if="isLoggedIn">
                  <i class="bookmark-true fa fa-bookmark" title="Remove this article to your favorites"
                    @click="unsaveArticle(article);" v-if="favorites.includes(article.id)">
                  </i>
                  <i class="bookmark-false fa fa-bookmark-o" title="Add this article from your favorites"
                    @click="saveArticle(article);" v-else>
                  </i>
                </span>
                <a :href="`/knowledge-base/${article.id}/${URLSlugify(article.title)}`">{{ article.title }}</a>
              </li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * Handles the listing of knowledge base links.
 * Associated files: 'knowledge-base.js', 'url.js', and 'knowledge-base.blade.php'
 * @displayName Knowledge Base List
 */

import url from '../../mixins/url';
import Spinner from '../Spinner.vue';

export default {
  name: 'knowledge-base-list',

  mixins: [url],

  components: {
    Spinner,
  },

  data() {
    return {
      myArticles: [],
      categories: [],
      favorites: [],
      searchText: '',
      loadingCategories: true,
      articleCategories: [],
      article: {},
    }
  },

  computed: {
    isLoggedIn() {
      return this.$root.isLoggedIn;
    }
  },

  mounted() {
    this.getArticles();

    if (this.isLoggedIn) {
      this.getArticleFavorites();
    }
  },

  watch: {
    isLoggedIn: function () {
      this.getArticleFavorites();
    }
  },

  methods: {
    getArticleFavorites() {
      let userDocsUrl = '/api/proxify/me/articles';
      axios.get(userDocsUrl)
        .then(({ data: response }) => {
          this.myArticles = response;

          for (let favorite of response) {
            this.favorites.push(favorite.id);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },

    getArticles() {
      let vm = this;

      let articleCategoriesUrl = '/api/proxify/domains/prismatic/shop/categories';
      let queryParams = {
        type: 'article',
        fields: 'id,name,'
      };

      axios.get(articleCategoriesUrl, { params: queryParams })
        .then(({ data: response }) => {
          vm.categories = response.data;

          const fetchArticlePromises = response.data.map(articleCategory => {
            let categoryArticlesUrl = `/api/proxify/domains/prismatic/shop/categories/${articleCategory.id}/articles`;
            return axios.get(categoryArticlesUrl, { params: { fields: 'id,title' } })
              .then(({ data: response }) => {
                return {
                  category: articleCategory,
                  articles: response.data
                };
              })
              .catch(error => {
                console.log(error);
                return null;
              });
          });

          Promise.all(fetchArticlePromises)
            .then(articleGroups => {
              vm.articleCategories = articleGroups.filter(group => group !== null);
              vm.loadingCategories = false;
            });
        })
        .catch(error => {
          console.log(error);
        });
    },


    saveArticle(article) {
      let vm = this;
      let userDocUrl = `/api/proxify/me/articles/${article.id}`;
      axios.put(userDocUrl)
        .then(({ data: response }) => {
          vm.favorites.push(article.id);
        })
        .catch(error => {
          console.log(error);
        });
    },

    unsaveArticle(article) {
      let vm = this;
      let userDocUrl = `/api/proxify/me/articles/${article.id}`;
      axios.delete(userDocUrl)
        .then(({ data: response }) => {
          vm.favorites = vm.favorites.filter(e => e !== article.id);
        })
        .catch(error => {
          console.log(error);
        });
    },

    mobileSearchArticles() {
      if (this.searchText.length > 2) {
        this.searchArticles();
      }
    },

    searchArticles() {
      let vm = this;
      vm.loading = true;

      let queryParams = {};
      if (vm.searchText.length) {
        queryParams.q = vm.searchText;
      } else {
        vm.showSearchResults = false;
        return;
      }

      let searchDocsUrl = `/api/proxify/domains/prismatic/articles`;
      axios.get(searchDocsUrl, {
        params: queryParams
      })
        .then(({ data: response }) => {
          vm.showSearchResults = true;
          vm.searchedArticles = response.data;
        })
        .catch(error => {
          console.log(error);
        });

      vm.loading = false;
    },
  }
}
</script>

<style lang="scss" scoped>
form {
  input {
    position: relative;
    vertical-align: top;
    background-color: transparent !important;
  }

  >span {
    position: relative;
    display: inline-block;
  }
}

ol {
  margin-left: 25px;

  >li>a {
    line-height: 4.0rem;
  }
}

.bookmark-true,
.bookmark-false {
  transition: color .3s;
  font-size: initial;
  cursor: pointer;
  min-width: 2rem;
  flex: 0 1 4rem;
}

.bookmark-false {
  color: #888888;

  &:hover {
    color: #7ED323;
  }
}

.bookmark-true {
  color: #7ED323;
}
</style>